import React, { Fragment, useState, useEffect } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faCheck } from "@fortawesome/free-solid-svg-icons";
import AlertModal from '../../../../shared/components/Modal';
import ApiClinicalStudio from '../../api/clinical_studio_api';
import ModalUpdateExcludeInclude from './ModalUpdateExcludeInclude';

const ListExcludeIncludeActions = ({ data, state }) => {
    const history = useHistory();
    //const feasibility = data.original.feasibility;
    const [openModal, setOpenModal] = React.useState(false);

    const [showDeleteModal, setDeleteModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);

    useEffect(() => {

    }, []);

    const deleteIncludeExclude = () => 
    {
        let dataCriterial = new FormData();
        dataCriterial.append("id_criterio", data.original.id_criterio);
        fetch(`${process.env.REACT_APP_PUBLIC_URL}criteriose/delete`, {
            method: 'DELETE',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataCriterial
        }).then(response => response.json()).then(data => {
            finishDeleteModal();
        }).catch(error => setErrorModal(false));
        
    }

    const openUpdateModal = () => 
    {
        setOpenModal(true);
    }

    const finishDeleteModal = () => 
    {
        let _url = "/clinical-studio/criterial-exclude-include";
        if (window.location.pathname === process.env.PUBLIC_URL + _url) {
            history.replace(process.env.PUBLIC_URL );
            setTimeout(() => {
                history.push({
                    pathname: process.env.PUBLIC_URL +_url,
                    state: data.original.feasibility
                });
            }, 0);
        }
    }

    return (<Fragment>
        <td role="cell">
            <IconButton style={{ fontSize: '15px' }} onClick={() => openUpdateModal()}>
                <FontAwesomeIcon icon={faEdit} />
            </IconButton>
            <IconButton style={{ fontSize: '15px' }} onClick={() => setDeleteModal(true)}>
                <FontAwesomeIcon icon={faTrashAlt} />
            </IconButton>

            <AlertModal
                color="warning"
                title="Esta seguro de eliminar este criterio?"
                modal={showDeleteModal}
                onOk={() => deleteIncludeExclude()}
                toggle={() => setDeleteModal(false)}
            />

            <AlertModal
                color="success"
                title="Criterio eliminado correctamente"
                modal={successModal}
                onOk={() => finishDeleteModal(false)}
                toggle={() => setSuccessModal(false)}
            />

            <AlertModal
                color="danger"
                title="Ha ocurrido un error al eliminar el Criterio"
                modal={errorModal}
                onOk={() => setErrorModal(false)}
                toggle={() => setErrorModal(false)}
            />

            <ModalUpdateExcludeInclude 
            criterial={data.original}
            closeIncludeExcludeModal={() => setOpenModal(false)}
            opened={openModal}
            />
        </td>
    </Fragment>)
}

export default reduxForm({
    form: `modal-form`, // a unique identifier for this form
})(withTranslation('common')(ListExcludeIncludeActions));